<script>
import { mapGetters, mapActions } from "vuex";

import SignIn from "./views/SignIn.vue";

import Sidebar from "./components/layout/Sidebar.vue";
import Header from "./components//layout/Header.vue";
import FormularioCorreo from "./views/recuperar/FormularioCorreo.vue";
import axios from "axios";
import Navigation from "./views/Menu/Navigation.vue";

export default {
  components: {
    Sidebar,
    Header,
    SignIn,
    FormularioCorreo,
    Navigation,
  },
  computed: {
    ...mapGetters({
      authenticated: "auth/authenticated",
      user: "auth/user",
      isNavOpen: "nav/isNavOpen",
    }),
    isPanelOpen() {
      return this.isNavOpen;
    },
  },
  data() {
    return {
      show: true,
      pantalla: false,
    };
  },
  mounted() {
    if (screen.width <= 1024) {
      this.pantalla = true;
    } else {
      this.pantalla = false;
    }
  },

  methods: {
    ...mapActions({
      signOutAction: "auth/signOut",
    }),

    async signOut() {
      if (this.authenticated) {
        await axios
          .post("logout")
          .then((res) => {})
          .catch((err) => console.log(err));
      }
      this.signOutAction();
      this.$router.push({ name: "SignIn" });
    },
  },
};
</script>

<template>
  <div id="app" class="h-screen overflow-clip">
    <div v-if="!authenticated">
      <router-view />
    </div>
    <div v-else class="h-full">
      <transition name="slide">
        <div
          v-if="isPanelOpen && pantalla == true"
          class="sidebar sidebar-panel"
        >
          <navigation :pantalla="pantalla"></navigation>
        </div>
      </transition>

      <div id="sidebar-wrapper" class="side-wrap p-0">
        <navigation></navigation>
      </div>

      <div
        class="bg-[#f0f5fa] h-full pt-12 px-4 pb-4 lg:ml-[230px] overflow-auto"
      >
        <Header :pantalla="pantalla" :signOut="signOut" :user="user" />
        <div>
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>
